import { Status as t } from "../../../../../common/shared/status.js";
import { Model as a } from "../../model.js";
class c extends a {
  constructor(o) {
    super(), this.google = o.google, this.facebook = o.facebook;
  }
  getCodes() {
    var e, s, g, i;
    const o = {};
    return ((e = this.google) == null ? void 0 : e.status) === t.ENABLED && (((s = this.google.ga) == null ? void 0 : s.status) === t.ENABLED && this.google.ga.measurementId && (o.ga = this.google.ga.measurementId), ((g = this.google.gtm) == null ? void 0 : g.status) === t.ENABLED && this.google.gtm.containerId && (o.gtm = this.google.gtm.containerId)), (i = this.facebook) != null && i.pixelId && (o.pixel = this.facebook.pixelId), o;
  }
}
export {
  c as AnalyticsModel
};
//# sourceMappingURL=analytics.model.js.map
